module.exports = __webpack_public_path__ + "img/vehiclegiallo.d70f023b.png";